// data/resourcesData.js

export const resourcesData = [
  {
    id: 1,
    slug: 'dynamic-routing-electric-utilities',
    categories: ['utilities', 'route-optimization'],
    date: '2026-06-15',
    tr: {
      title: 'Elektrik Dağıtım Şebekelerinde Dinamik Rota Optimizasyonu',
      excerpt: 'Elektrik dağıtım şebekelerindeki acil arıza müdahalelerinde VRP bazlı anlık rerouting yaklaşımları ve saha kazanımları.',
      author: 'Conveks Optimizasyon Lab'
    },
    en: {
      title: 'Dynamic Route Optimization in Electricity Distribution Networks',
      excerpt: 'How VRP-based real-time rerouting algorithms improve emergency outage response times and fuel efficiency in utilities.',
      author: 'Conveks Optimizasyon Lab'
    }
  },
  {
    id: 2,
    slug: 'first-time-fix-rates-telecom',
    categories: ['workforce-management', 'scheduling'],
    date: '2026-05-28',
    tr: {
      title: 'Telekom Operasyonlarında İlk Seferde Onarım (FTF) Oranını Artırmak',
      excerpt: 'Yapay zeka tabanlı yetkinlik-görev eşleştirme algoritmalarının saha ekipleri verimliliğine etkisi.',
      author: 'Conveks Optimizasyon Lab'
    },
    en: {
      title: 'Boosting First-Time Fix (FTF) Rates in Telecom Operations',
      excerpt: 'Evaluating the impact of AI-driven skill-to-task matching models on field engineer service productivity.',
      author: 'Conveks Optimizasyon Lab'
    }
  },
  {
    id: 3,
    slug: 'mixed-integer-linear-programming-scheduling',
    categories: ['scheduling', 'technical-documentation'],
    date: '2026-04-12',
    tr: {
      title: 'Karma Tam Sayılı Programlama ile Büyük Ölçekli Görev Çizelgeleme',
      excerpt: 'Heuristik yaklaşımlar ve MIP kısıtlı çözüm motorlarının milisaniyeler bazında saha operasyonlarına entegrasyonu.',
      author: 'Conveks Optimizasyon Lab'
    },
    en: {
      title: 'Mixed Integer Linear Programming in Large-Scale Job Scheduling',
      excerpt: 'Integrating heuristic approaches and MIP constrained solvers inside real-time field operations dispatch networks.',
      author: 'Conveks Optimization Lab'
    }
  },
  {
    id: 4,
    slug: 'last-mile-optimization-logistics',
    categories: ['logistics', 'route-optimization'],
    date: '2026-03-05',
    tr: {
      title: 'Lojistik Sektöründe Son Kilometre (Last-Mile) Teslimat Verimliliği',
      excerpt: 'Trafik yoğunluğu, teslimat pencereleri ve dinamik teslimat iptalleri altında akıllı TSP algoritması uygulamaları.',
      author: 'Conveks Optimizasyon Lab'
    },
    en: {
      title: 'Optimizing Last-Mile Logistics under Real-Time Constraints',
      excerpt: 'Applying adaptive Traveling Salesperson (TSP) heuristics to navigate traffic fluctuations and customer cancellations.',
      author: 'Conveks Optimizasyon Lab'
    }
  }
];
